<template>
  <ModalBase
    :name="$attrs.name"
    :size="size"
    :clickToClose="clickToClose"
    :showClose="showClose"
    @before-open="$emit('before-open', $event)"
    @before-close="$emit('before-close', $event)"
    @opened="$emit('opened', $event)"
    @closed="$emit('closed', $event)"
    :title="title"
    :slotContainerClass="containerClass"
  >
    <div>
      <div class="mt-3 sm:mt-5">
        <div class="mt-2 px-5">
          <p class="text-sm text-gray-500" v-if="description">
            {{ description }}
          </p>
          <slot v-if="$slots.default"></slot>
        </div>
      </div>

      <div
        class="px-5 pt-5 pb-1 mt-5 sm:mt-6 flex justify-end border-t"
        v-if="buttons.length"
      >
        <IAButton
          v-for="(item, index) in buttons"
          :key="`modal_${$attrs.name}_button_${index}`"
          :title="item.text"
          :click="item.click"
          class="border-transparent"
          :class="item.classList"
          size="medium"
          :disabled="item.disabled"
          :loading="item.loading"
        />
      </div>
    </div>
  </ModalBase>
</template>
<script>
import ModalBase from "./ModalBase.vue";
export default {
  name: "ModalMessage",
  components: { ModalBase },
  /*
      Not listed as a prop, but this component _requires_ a name attribute.
    */
  props: {
    /* Used to pass through to ModalBase */
    clickToClose: {
      type: Boolean,
      default: false
    },
    /* Used to pass through to ModalBase */
    showClose: {
      type: Boolean,
      default: false
    },
    /* All below are unique to this modal */
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    icon: {
      type: Array,
      default: () => []
    },
    iconClass: {
      type: String,
      default: ""
    },
    buttons: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: "medium"
    },
    containerClass: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  }
};
</script>
